import { render, staticRenderFns } from "./NewSalesReport.vue?vue&type=template&id=c19a3aae"
import script from "./NewSalesReport.vue?vue&type=script&lang=ts"
export * from "./NewSalesReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports